import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import App from './app';
import './index.scss';
import { store } from './redux/store';
import reportWebVitals from './reportWebVitals';
import 'rc-tabs/assets/index.css';
import 'react-image-gallery/styles/image-gallery.css';
import 'font-awesome/css/font-awesome.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/rc-tab.override.css';
import "./assets/scss/image-gallery.override.css";
import 'react-rangeslider/lib/index.css';
import 'rc-slider/assets/index.css';
import { createBrowserHistory } from 'history';

if (process.env.NODE_ENV === 'development') {
  require('./assets/tailwind/output.css')
} else if (process.env.NODE_ENV === 'production') {
  require('./assets/tailwind/input.css')
}

const container = document.getElementById('root')!;

// Create a client
const queryClient = new QueryClient()

export const history = createBrowserHistory();

createRoot(container).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <ToastContainer theme='colored'/>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen />
    </QueryClientProvider>
  </Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
